import { render, staticRenderFns } from "./ParticipantRemote.vue?vue&type=template&id=4e5ff8ed&scoped=true&"
import script from "./ParticipantRemote.vue?vue&type=script&lang=js&"
export * from "./ParticipantRemote.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantRemote.vue?vue&type=style&index=0&id=4e5ff8ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5ff8ed",
  null
  
)

export default component.exports